import { interpolate } from "flubber";
import React, { RefObject } from "react";
import { Animated, Easing, Platform, StyleProp, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, Path as SVG_Path, Rect as SVG_Rect } from "react-native-svg";
import { kColors } from "src/kColors";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const Path = Animated.createAnimatedComponent(SVG_Path);
const Rect = Animated.createAnimatedComponent(SVG_Rect);
const G = Animated.createAnimatedComponent(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
/***/

/**
 *
 *  /$$$$$$                               /$$$$$$$  /$$
 * |_  $$_/                              | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$       | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$      | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$      | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$      | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  __  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |$$| |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 */

/*
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE">{"morph":{"condition":"props.morph","targets":{"state=off":{"type":"ease","duration":250,"delay":0},"state=on":{"type":"ease","duration":250,"delay":0}},"numStates":2},"tProps":{"type":"PROPS","button?":{"onPress":"Function"}},"#button":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.button?.onPress"}}}</desc>
 * <g id="state=off">
 * <rect id="Box" x="1" y="1" width="13" height="13" rx="1" stroke="black" stroke-width="2"/>
 * <circle id="Fill" opacity="0.01" cx="7.5" cy="7.5" r="0.5" fill="black"/>
 * <rect id="button" width="15" height="15" rx="2" fill="white" fill-opacity="0.01"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
 * <g id="state=on">
 * <rect id="Box" x="1" y="1" width="13" height="13" rx="1" stroke="black" stroke-width="2"/>
 * <rect id="Fill" x="2" y="2" width="11" height="11" fill="black"/>
 * <path id="Check" fill-rule="evenodd" clip-rule="evenodd" d="M12.774 4.63324L7.20847 11.4355L2.33939 7.15071L3.66064 5.64928L6.97337 8.56449L11.2261 3.36676L12.774 4.63324Z" fill="white"/>
 * <rect id="button" width="15" height="15" rx="2" fill="white" fill-opacity="0.01"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"state=off": {
 * 				"type": "ease",
 * 				"duration": 250,
 * 				"delay": 0
 * 			},
 * 			"state=on": {
 * 				"type": "ease",
 * 				"duration": 250,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 2
 * 	},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"button?": {
 * 			"onPress": "Function"
 * 		},
 * 		"morph?": "number",
 * 		"maxSegmentLength?": "number",
 * 		"state?": "\"off\" | \"on\"",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#button": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.button?.onPress",
 * 			"animation": "touchableOpacity"
 * 		}
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: StyleProp<ViewStyle>;
  debug?: boolean;
  svgRef?: unknown;
  button?: {
    onPress: () => void;
  };
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  state?: "off" | "on";
  onAnimationComplete?: () => void;
};
/***/

/** Morphing Types */

type tMorphRef = Animated.WithAnimatedValue<React.Ref<React.Component<unknown, unknown, unknown>>> &
  React.Ref<React.Component<unknown, unknown, unknown>>;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d }: { d: string }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigFillopacity: string | Animated.AnimatedInterpolation;
  morphConfigFilld: string | Animated.AnimatedInterpolation;
  morphConfigCheckopacity: string | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const CheckboxTwo = (props: {
  style?: StyleProp<ViewStyle>;
  debug?: boolean;
  svgRef?: unknown;
  button?: {
    onPress: () => void;
  };
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  state?: "off" | "on";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const { svgRef, button, maxSegmentLength = 1, onAnimationComplete = () => 0 } = props;
  /** Component Internal State */

  const [buttonState, setButtonState] = React.useState<{
    buttonButtonOpacity: number;
  }>({
    buttonButtonOpacity: 1,
  });
  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigFillopacity: "0.01",
      morphConfigFilld: "M8 7.5 A0.5 0.5 0 0 1 7.5 8 A0.5 0.5 0 0 1 7 7.5 A0.5 0.5 0 0 1 8 7.5z",
      morphConfigCheckopacity: "0",
    },
  });
  /** End Custom React-Hooks */

  /** Button Wrapper */
  // #region button Button Handlers

  const buttonButtonPressInFunction = () => 0;

  const buttonButtonPressOutFunction = button?.onPress;

  const buttonButtonActive = (callback?: () => void) => {
    setButtonState({ ...buttonState, buttonButtonOpacity: 0.2 });

    if (callback) {
      callback();
    }
  };

  const buttonButtonInactive = (callback?: () => void) => {
    setButtonState({ ...buttonState, buttonButtonOpacity: 1 });

    if (callback) {
      callback();
    }
  };

  const buttonOnPressIn = () => {
    buttonButtonActive(buttonButtonPressInFunction);
  };

  const buttonOnPressOut = () => {
    buttonButtonInactive(buttonButtonPressOutFunction);
  };
  /***/
  // #endregion

  /** End Button Wrapper */

  /** Morph Wrapper */

  type tMorphProperty = {
    state: "off" | "on";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      state: "off",
    },
    1: {
      state: "on",
    },
  };

  function getNextMorphState(): number {
    const { state, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].state === state) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 1;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) =>
    Number((x - Math.min(bound1, bound2)) / (Math.max(bound1, bound2) - Math.min(bound1, bound2)));
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<{
      morphId: keyof tMorphProps;
      paths: string[];
    }>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      const interpolators: {
        [morphId: string]: {
          initial: string;
          final: string;
          interpolator: (t: number) => string;
        };
      } = {};
      interpolations.forEach(({ morphId, paths }) => {
        const initial = paths[start];
        const final = paths[end];
        const p1 = start > end ? final : initial;
        const p2 = start > end ? initial : final;
        const interpolator = interpolate(p1, p2, {
          maxSegmentLength,
        });
        interpolators[morphId] = {
          initial,
          final,
          interpolator,
        };
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.keys(interpolators).forEach((morphId) => {
          const { final, interpolator } = interpolators[morphId];
          let nextInterpolatedPath: string;

          if (value % 1 === 0) {
            nextInterpolatedPath = final;
          } else {
            nextInterpolatedPath = interpolator(normalize(value, start, end));
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
            } else {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [start, end]);
    return ((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown as tMorphRef;
  };

  morphProps.bindInterpolation = useGenerateMorphInterpolation(
    [
      {
        morphId: "morphConfigFilld",
        paths: ["M8 7.5 A0.5 0.5 0 0 1 7.5 8 A0.5 0.5 0 0 1 7 7.5 A0.5 0.5 0 0 1 8 7.5z", "M2 2 H13 V13 H2 V2z"],
      },
    ],
    startValue,
    endValue,
  );
  const morphValues: {
    [id: string]: Array<string>;
  } = {
    morphConfigFillopacity: ["0.01", "1"],
    morphConfigCheckopacity: ["0", "1"],
  };

  function clamp(lower: number, upper: number, v: number) {
    let r = v;

    if (r > upper) {
      r = upper;
    } else if (r < lower) {
      r = lower;
    }

    return r;
  }

  function getInterpolationRange(
    morphId: string,
    start: number,
    end: number,
  ): {
    inputRange: number[];
    outputRange: string[];
  } {
    const initial = clamp(0, 2, start);
    const final = clamp(0, 2, end);
    const inputRange = [start, end];
    const outputRange = [morphValues[morphId][initial], morphValues[morphId][final]];

    if (start > end) {
      inputRange.reverse();
      outputRange.reverse();
    }

    return {
      inputRange,
      outputRange,
    };
  }

  morphProps.morphConfigFillopacity = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigFillopacity", startValue, endValue),
  );
  morphProps.morphConfigCheckopacity = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigCheckopacity", startValue, endValue),
  );
  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 250,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 250,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 15 15" fill="none" id="svg_root" ref={svgRef as RefObject<unknown>} {...props}>
      <G id="state_3Doff">
        <Rect id="Box" x={1} y={1} width={13} height={13} rx={1} stroke={kColors.brandDarkRed} strokeWidth={2} />
        <Path
          id="Fill"
          fill={kColors.brandDarkRed}
          d="M8 7.5 A0.5 0.5 0 0 1 7.5 8 A0.5 0.5 0 0 1 7 7.5 A0.5 0.5 0 0 1 8 7.5z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          opacity={morphProps.morphConfigFillopacity}
        />
        <Rect
          id="button"
          width={15}
          height={15}
          rx={2}
          fill="white"
          fillOpacity={0.01}
          opacity={buttonState.buttonButtonOpacity}
          onPressIn={buttonOnPressIn}
          onPressOut={buttonOnPressOut}
          onMouseDown={buttonOnPressIn}
          onMouseUp={buttonOnPressOut}
          cursor="pointer"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          id="Check"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          fill={"white"}
          opacity={morphProps.morphConfigCheckopacity}
          d={
            "M12.774 4.63324L7.20847 11.4355L2.33939 7.15071L3.66064 5.64928L6.97337 8.56449L11.2261 3.36676L12.774 4.63324Z"
          }
        />
      </G>
    </Svg>
  );
};
/***/

export default CheckboxTwo;
